<template>
  <div class="fzmProductDetails">

    <div class="pageinfowrapper">
        <h1>12 Count <span class="fzmBreakLine"></span> Holes Donuts</h1>

        <p>Lorem ipsum consectetur adipiscing elit sed do eiusmod tempor incididunt ut lorem. Minimum order of {{minbox}} dozen.</p>
        <p><small>Note : Unselect flavor to change</small></p>
    </div>


    <b-dropdown 
        class="boxtypedropdown" 
        v-if="boxtypes">

        <template #button-content>
            {{boxtype ? boxtype.box_name : 'Select'}} <b-icon icon="chevron-down"></b-icon>
        </template>
        
        <template v-for="type in boxtypes">
            <b-dropdown-item-btn 
                @click="selectboxtype(type)"
                :key="type.id">{{type.box_name}}</b-dropdown-item-btn>
        </template>
    </b-dropdown>

    <div class="listOfFlavors">
        <div class="flavorItems">
            <template v-for="flavor in flavors">
                 <div :key="flavor.id" 
                    @click="selectflavor(flavor.id)"
                    v-b-tooltip.hover
                    :title="flavor.name"
                    :style="`border-color : ${flavor.color}; background-color : ${box ? box.flavors.includes(flavor.id) ? flavor.color : '' : ''}`"
                    :class="[`flavor`, {'active' : box ? box.flavors.includes(flavor.id) : ''}]">

                    <img :src="flavor.icon_image_url" :alt="flavor.name">
                </div>
            </template>
            
        </div>
    </div>
</div>
</template>

<script>
/**
 * Declerations
 */
// mixins
import {ordermixins} from '@/mixins/ordermixins'

export default {
    mixins : [ordermixins],
    props : {
        /**
         * active box will have default first box open
         */
        activebox : {
            type : Number,
            default: () => {
                return 0;
            }
        }
    },  
    computed : {
        /**
         * min order boxes
         */
        minbox() {
            return this.$store.state.minbox
        },
        /**
         * Box type options
         * Each type will have filter function when selecting flavors
         * @example if type 4 flavors use can only select 4 flavors 3 of each
         */
        boxtypes() {
            return this.$store.state.ordertypes.filter(t => t.box_type == 'subscription' || t.box_type == 'all')
        },
         /**
         * User order box list
         */
        orderboxes() {
            return this.$store.state.orderboxes
        },
        /**
         * Flavors from store
         */
        flavors() {
            return this.$store.state.flavors
        },
        box : {
            get() {
                /**
                 * Get box data base on active box index
                 */
                const box = this.orderboxes;

                return box[this.activebox];
            },
            set(box) {
                /**
                 * Update box data
                 */
                this.updatebox(box);
            }
        },
        /**
         * Get box type 
         */
        boxtype() {
            if(this.box) {
                return this.boxtypes.find(t => t.id == this.box.id)
            } else {
                return this.boxtypes[0];
            }
        }
    },
    methods : {
        /**
         * Update box data and push to vuex
         */
        updatebox(box) {
            this.orderboxes[this.box] = box;
        },
        /**
         * Get absolute path of image from local file
         */
        getimageurl(img) {
            return require(`@/assets/img/flavorIcons/${img}`)
        },
        /**
         * Update order box type
         */
        selectboxtype(type) {
            /**
             * Update type 
             * and reset flavors when changing flavors
             * set is complete to false
             */
            let box          = this.box;
                box.box_name = type.box_name;
                box.flavors  = [];
                box.price    = parseFloat(type.box_price);
                box.id       = type.id;
                this.box     = box;

            /**
             * Check if assorted is selected
             * Fill the box automatically
             */
            if(type.box_name.toLowerCase().match('assorted')) {
                this.selectflavor();
            }

            /**
             * Set edit flag
             */
            this.setflagboxchange('boxitem')
        },
        /**
         * Update flavor array
         * Filter flavor selection base on what type of order user selected
         */
        selectflavor(flavor) {
            let   box     = this.box;
            const boxtype = this.boxtype;
           
            // /**
            //  * For now static checking of how many flavor per box type
            //  * If 1 flavor 
            //  * user can select 1 flavor only
            //  */
            // console.log(boxtype);
            // if(boxtype.box_name.toLowerCase().match('1 flavor')) {
            //     box.flavors    = new Array(numberofflavors).fill(flavor);
            // }  

            // /**
            //  * 4 flavors
            //  * user can select up to 4 flavors and each flavor will occupied 3 spots
            //  */

            // else if(boxtype.box_name.toLowerCase().match('4 flavors')) {
            //     const newflavors = new Array(3).fill(flavor);

            //     /**
            //      * Check if flavor already added then remove from the list
            //      */
            //     if(box.flavors.includes(flavor)) {
            //         box.flavors = box.flavors.filter(f => f != flavor);
            //     } else if(box.flavors.length < 12) {
            //         box.flavors = [...box.flavors, ...newflavors];
            //     }
            // }

            /**
             * Assorted
             * Automatically fill flavors with 1 of each flavor
             */
            if(boxtype.box_name.toLowerCase().match('assorted')) {
                box.flavors = this.flavors.map(f => f.id);
            } else {
                /**
                 * Check box type how many flavor allow per box
                 * 
                 */
                const numberofflavors = 12 /  boxtype.limit_flavors;

                 /**
                 * Check if flavor already added then remove from the list
                 */
                const newflavors = new Array(numberofflavors).fill(flavor);

                if(box.flavors.includes(flavor)) {
                    box.flavors = box.flavors.filter(f => f != flavor);
                } else if(box.flavors.length < 12) {
                    box.flavors = [...box.flavors, ...newflavors];
                }

            }

            this.box = box;

             /**
             * Set edit flag
             */
            this.setflagboxchange('boxitem')
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';
@import '@/scss/global/_mixins.scss';

.fzmProductPage {
    .fzmProductDetails {
        @include screen-up(sm) {
            padding-left : 0;
            padding-right: 0;
        }

        .boxtypedropdown {
            @include screen-up(sm) {
                margin-top : 0;
            }
        }
    
        .flavorItems {
            .flavor  {
                padding : 10px;

                @include screen-up(sm) {
                    width        : 50px;
                    height       : 50px;
                    padding      : 5px;
                    margin-right : 10px;
                    margin-bottom: 10px;
                }
    
                img {
                    width : 100%;
                }
    
                &.active {
                    img {
                        filter: brightness(0) invert(1);
    
                    }
                }
            }
        }
    
        .pageinfowrapper {
            @include screen-up(sm) {
                display: none;
            }
        }
    
        .dropdown {
            &.show {
                .dropdown-toggle {
                    color           : white;
                    background-color: $primary-color;
                }
            }
    
            .dropdown-toggle {
                border-radius: 30px;
                padding-left : 30px;
                padding-right: 0;
                color        : $black;
                font-weight  : 700;
    
                &:hover, &:focus {
                    color : white;
                }
    
                &::after {
                    display: none;
                }
    
                svg {
                    margin-left : 5px;
                    margin-right: 15px;
                    font-size   : 12px;
                    position    : relative;
                    top         : -2px;
                }
            }
        }
    }
}

</style>